import { fetchAuthSession, getCurrentUser } from 'aws-amplify/auth'
import User from '@/models/User'

export const AUTH_START_PATH =
	(process.env.VUE_APP_API_URL || '/api/v3/') + 'auth/authenticator?phase=initiate-login&auto=1'
const AUTH_LOGOUT_PATH = (process.env.VUE_APP_API_URL || '/api/v3/') + 'auth/authenticator?phase=logout'

export async function hasValidSession() {
	if (globalThis.localStorage.getItem('isTesting')) {
		return true
	}
	try {
		await getCurrentUser()
		return true
	} catch (e) {
		return false
	}
}

export async function ensureValidSession(opts?: { redirectTo?: string; returnTo?: string }) {
	if (!globalThis.localStorage.getItem('isTesting')) {
		try {
			await getCurrentUser()
			const { tokens } = await fetchAuthSession()
			if (!tokens?.accessToken) {
				redirectToAuth(opts)
				return false
			}
		} catch {
			redirectToAuth(opts)
			return false
		}
	}

	try {
		await User.fetchMeLazy()
	} catch (e: any) {
		if (e.message.includes('401')) {
			redirectToAuth(opts)
			return false
		}
		throw e
	}

	return true
}

export async function logout() {
	// @ts-ignore
	globalThis.NREUM?.setUserId(null)
	globalThis.location.assign(AUTH_LOGOUT_PATH)
}

function redirectToAuth(opts?: { redirectTo?: string; returnTo?: string }) {
	const redirectBase = opts?.redirectTo ?? AUTH_START_PATH
	const returnTo = opts?.returnTo ?? globalThis.location.href
	let url = `${redirectBase}&returnTo=${encodeURIComponent(returnTo)}`

	const currentQueryParams = new URLSearchParams(window.location.search)
	if (currentQueryParams.has('user')) {
		url += `&user=${encodeURIComponent(currentQueryParams.get('user') || '')}`
	}

	globalThis.location.assign(url)
}
